import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {EventService} from "../../../../../service/api/event.service";
import {MessageToastService} from "../../../../../service/message-toast.service";
import {finalize, tap} from "rxjs";
import {ApiResponse} from "../../../../../shared/model/response/ApiResponse";

@Component({
    selector: 'app-transfer-all-events-modal',
    templateUrl: './transfer-all-events-modal.component.html',
    standalone: false
})
export class TransferAllEventsModalComponent implements OnInit{
  @Output('onCloseModal') onCloseModal = new EventEmitter<any>();

  verificationText = "Transferir Tudo"

  form: FormGroup;
  formErrors: Map<string, string> = new Map();

  isLoading = false

  constructor(
    private eventService: EventService,
    private toastService: MessageToastService
  ) {
  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm(): void {
    this.form = new FormGroup({
      "email": new FormControl(null, Validators.required),
      "verification": new FormControl(null, Validators.required),
    });

  }

  apiOnTransfer() {
    this.formErrors?.clear()
    this.isLoading = true

    const req = {email: this.form.get("email").value,}

    this.eventService.transferAccountEvents(req)
      .pipe(tap({
          next: (response) => {
            this.toastService.success(response.message)
            this.form.reset()
            this.onCloseModal.emit()
          },
          error: (err: ApiResponse<any>) => this.toastService.error(err.message)
        })
        , finalize(() => this.isLoading = false)
      )
      .subscribe();
  }
}
